export const getNormalFontWeight = (lang: string) => {
  const normalFontWeight = ['zhCN', 'jaJP', 'koKR'].includes(lang) ? 400 : 500;

  return normalFontWeight;
};
